import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35ebd6f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users p-20 flex column gap-12" }
const _hoisted_2 = { class: "list flex column overflow-hidden gap-20 overflow-hidden p-20" }
const _hoisted_3 = { class: "ops flex align-center" }
const _hoisted_4 = { class: "business-list flex-1 overflow-overlay flex column overflow-scroll gap-60" }
const _hoisted_5 = {
  key: 0,
  class: "operators flex column gap-8"
}
const _hoisted_6 = { class: "editor-area flex column gap-8 flex-1" }
const _hoisted_7 = { class: "right-input flex column flex-1 gap-12" }
const _hoisted_8 = { class: "flex column flex-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text text-align-left title" }, "標題", -1))
const _hoisted_10 = {
  key: 0,
  class: "text-align-left"
}
const _hoisted_11 = { class: "flex column flex-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text text-align-left title" }, "說明", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-align-left"
}
const _hoisted_14 = { class: "images flex align-center overflow-overlay gap-8" }
const _hoisted_15 = {
  key: 0,
  class: "image-container"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "operator flex align-center justify-center"
}
const _hoisted_18 = {
  key: 1,
  class: "empty-image"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "operator flex align-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_dynamic_form = _resolveComponent("dynamic-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "full-page flex column p-20 overflow-hidden",
      ref: "form",
      model: _ctx.form,
      "label-width": "0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          class: "flex-1 flex align-stretch overflow-hidden",
          label: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.addBusiness
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增營業項目")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.startEdit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("修改")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.save
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.cancel
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("取消")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business, (data, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "business-item flex align-center gap-8 p-8 flex-auto",
                    key: `${idx}-${data.image}`
                  }, [
                    (_ctx.editMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_el_button, {
                            class: "m-0",
                            size: "mini",
                            disabled: idx === 0,
                            onClick: ($event: any) => (_ctx.goUp(idx))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("上移")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]),
                          _createVNode(_component_el_button, {
                            class: "m-0",
                            size: "mini",
                            onClick: ($event: any) => (_ctx.remove(idx))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("刪除")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            class: "m-0",
                            size: "mini",
                            disabled: idx === _ctx.business.length,
                            onClick: ($event: any) => (_ctx.goDown(idx))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下移")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          (!_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(data.title), 1))
                            : (_openBlock(), _createBlock(_component_el_input, {
                                key: 1,
                                modelValue: data.title,
                                "onUpdate:modelValue": ($event: any) => ((data.title) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          (!_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(data.description), 1))
                            : (_openBlock(), _createBlock(_component_el_input, {
                                key: 1,
                                class: "content-input flex-1",
                                type: "textarea",
                                wrap: "hard",
                                rows: "4",
                                modelValue: data.description,
                                "onUpdate:modelValue": ($event: any) => ((data.description) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (data.imageURL !== '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("img", {
                                src: data.imageURL
                              }, null, 8, _hoisted_16),
                              (_ctx.editMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      icon: _ctx.CaretLeft,
                                      disabled: ""
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      size: "mini",
                                      icon: _ctx.Delete,
                                      onClick: ($event: any) => (_ctx.removeMainImage(idx))
                                    }, null, 8, ["icon", "onClick"]),
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      icon: _ctx.CaretRight,
                                      onClick: ($event: any) => (_ctx.goRight(idx, -1)),
                                      disabled: data.subImageURLs.length === 0
                                    }, null, 8, ["icon", "onClick", "disabled"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.subImageURLs, (subImageURL, subIdx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subImageURL,
                            class: "image-container"
                          }, [
                            _createElementVNode("img", { src: subImageURL }, null, 8, _hoisted_19),
                            (_ctx.editMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createVNode(_component_el_button, {
                                    size: "mini",
                                    icon: _ctx.CaretLeft,
                                    onClick: ($event: any) => (_ctx.goLeft(idx, subIdx))
                                  }, null, 8, ["icon", "onClick"]),
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    size: "mini",
                                    icon: _ctx.Delete,
                                    onClick: ($event: any) => (_ctx.removeSubImage(idx, subIdx))
                                  }, null, 8, ["icon", "onClick"]),
                                  _createVNode(_component_el_button, {
                                    size: "mini",
                                    icon: _ctx.CaretRight,
                                    onClick: ($event: any) => (_ctx.goRight(idx, subIdx)),
                                    disabled: subIdx === data.subImageURLs.length - 1
                                  }, null, 8, ["icon", "onClick", "disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock(_component_el_upload, {
                              key: 2,
                              class: "add-image",
                              ref_for: true,
                              ref: "uploader",
                              action: "https://bat.bearathome.com.tw/api/image/upload",
                              "list-type": "picture-card",
                              accept: "image/png, image/jpeg, image/jpg",
                              headers: _ctx.uploadHeader,
                              onSuccess: _ctx.genHandleUploadSuccess(idx)
                            }, {
                              file: _withCtx(({ file }) => []),
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_upload_filled)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["headers", "onSuccess"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_dynamic_form, {
      ref: "addForm",
      title: "新增營業項目",
      columns: _ctx.businessColumns,
      onFinish: _ctx.handleAdd
    }, null, 8, ["columns", "onFinish"])
  ]))
}